import axios from "axios";
import { ethers } from "ethers";
import Web3 from "web3";
import logoLight from "../Images/pansea_white.png";
import logoDark from "../Images/pansea.png";
import logoLightTestnet from "../Images/pansea_white_testnet.png";
import logoDarkTestnet from "../Images/pansea_black_testnet.png";

// testnet: MaalChain Testnet V2 (7863)
// mainnet: MaalChain V2 (7862)
// The PanSea v2 contracts are deployed on both, at the same addresses (src/Web3/ABI.js).

const message = (wallet) => `Welcome to PanSea!

Click to sign in and accept the PanSea Terms of Service (https://pansea.io/terms) and Privacy Policy (https://pansea.io/privacy).

This request will not trigger a blockchain transaction or cost any gas fees.

Your authentication status will reset after 24 hours.`;

const isNetworkTestnet = false;

const NETWORK = isNetworkTestnet
  ? {
      chainId: 7863,
      chainIdHex: "0x1EB7",
      name: "MaalChain Testnet V2",
      rpc: "https://node-testnet.maalscan.io",
      explorer: "https://new-testnet.maalscan.io",
      faucet: "https://faucet-new-testnet.maalscan.io",
    }
  : {
      chainId: 7862,
      chainIdHex: "0x1EB6",
      name: "MaalChain V2",
      rpc: "https://node1-mainnet-new.maalscan.io",
      explorer: "https://v2.maalscan.io",
      faucet: undefined,
    };

export const isTestNet = () => {
  return isNetworkTestnet; //
};

let provide = NETWORK.rpc;

const RPC = NETWORK.rpc;

export const networkId = () => {
  return NETWORK.chainId;
};

export const networkIdHex = () => {
  return NETWORK.chainIdHex;
};

/** `wallet_addEthereumChain` parameters, for wallets that do not know the chain yet. */
export const networkParams = () => ({
  chainId: NETWORK.chainIdHex,
  chainName: NETWORK.name,
  nativeCurrency: { name: "MAAL", symbol: "MAAL", decimals: 18 },
  rpcUrls: [NETWORK.rpc],
  blockExplorerUrls: [NETWORK.explorer],
});

export const faucetURL = () => {
  return NETWORK.faucet;
};

export const SignMessages = async () => {
  try {
    await window.ethereum.send("eth_requestAccounts");
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    provide = window.ethereum;
    const user = await axios
      .post(`${window.apiURL}/getuser`, {
        wallet: await getAddress(),
      })
      .then((res) => {
        return res.data;
      });
    if (user.length <= 0) {
      const signature = await signer.signMessage(message(signer));
      const address = await signer.getAddress();
      const isVerify = await verifyMessage(message(signer), address, signature);
      if (isVerify) {
        await axios
          .post(`${window.apiURL}/makeuser`, {
            Creator: await getAddress(),
            signature: signature,
          })
          .then((res) => {
            return res.data[0].Creator;
          });
      }
      return isVerify;
    } else {
      const signature = user[0].signature ? user[0].signature : "00";
      const address = await signer.getAddress();
      const isVerify = await verifyMessage(message(signer), address, signature);

      if (isVerify) {
        return true;
      } else {
        const newsignature = await signer.signMessage(message(signer));
        const data = await axios
          .post(`${window.apiURL}/updateuser`, {
            wallet: await getAddress(),
            signature: newsignature,
          })
          .then((res) => {
            return res.data;
          });
        return true;
      }
    }
  } catch (err) {
    console.log(err);
  }
};

export const verifyMessage = async (message, address, signature) => {
  try {
    const signerAddr = await ethers.utils.verifyMessage(message, signature);
    if (signerAddr === address) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};

export const convertToLowercase = (str) => {
  let result = "";
  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i);
    if (charCode >= 65 && charCode <= 90) {
      result += String.fromCharCode(charCode + 32);
    } else {
      result += str.charAt(i);
    }
  }
  return result;
};

export const getAddress = async () => {
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    provide = window.ethereum;
    const address = await provider.send("eth_requestAccounts", []);
    const lower = convertToLowercase(address[0]);
    return lower;
  } catch (error) {
    console.log(error);
  }
};

export const getProvider = async () => {
  return new Web3(provide);
};

export const rpcURL = () => {
  return RPC;
};

export const GetChainId = async () => {
  try {
    const web3 = await getProvider();
    const id = await web3.eth.getChainId();
    return id;
  } catch (error) {}
};

export const userBalanceOfChain = async (userAddress) => {
  try {
    const data = await axios
      .post(RPC, {
        jsonrpc: "2.0",
        method: "eth_getBalance",
        params: [userAddress, "latest"],
        id: 880,
      })
      .then((res) => {
        const bal = parseInt(res.data.result, 16) / 10 ** 18;
        return Number(bal);
      })
      .catch((error) => {
        console.log(error);
      });
    return data;
  } catch (error) {
    console.log(error);
  }
};

// Wei amounts stay strings end to end. A JS number cannot hold most wei values,
// and the v2 contracts reject any native payment that is not exact (WrongPayment).
export const utils_towei = async (value) => {
  const pro = await getProvider();
  const num = await pro.utils.toWei(String(value).trim(), "ether");
  return num;
};

/** `pricePerUnit × quantity` in wei, exactly. */
export const multiplyWei = (wei, quantity) => {
  return Web3.utils.toBN(String(wei)).mul(Web3.utils.toBN(String(quantity))).toString();
};

/**
 * D2 (docs/NEW_CONTRACTS_PLAN.md in the backend): the collection's `fee` is the
 * royalty percent the creator types and the collection page shows (0 to 10), so
 * 5 means 5% = 500 basis points. Legacy sent it raw, paying 1/100 of that.
 * Capped at 1000 bps (10%), the v2 contracts' maximum.
 */
export const royaltyBpsFromFee = (fee) => {
  const bps = Math.round((Number(fee) || 0) * 100);
  return Math.min(Math.max(bps, 0), 1000);
};

export const utils_fromowei = async (value) => {
  const pro = await getProvider();
  const num = await pro.utils.fromWei(value, "ether");
  return num;
};

export const logo_light = () => (isNetworkTestnet ? logoLightTestnet : logoLight);

export const logo_dark = () => (isNetworkTestnet ? logoDarkTestnet : logoDark);

export const faucets = () => {
  //const logo = "https://bafkreiaqmyyk4gpy7v3unmli7phytdat6xzdtu7aji7mgzieuwlatmosli.ipfs.nftstorage.link" // mainnet
  const logo = isNetworkTestnet ? true : false; // tesnet
  return logo;
};
